// 权限
export const PERMISSION = 'PERMISSION'
// 当前模块权限
export const CURRENT_PERMISSION = 'CURRENT_PERMISSION'
// 视频教程
export const VEDIO_TEACH_DIALOG = 'VEDIO_TEACH_DIALOG'
// 案例详解
export const CASE_EXPLAIN_DIALOG = 'CASE_EXPLAIN_DIALOG'
// 常见问题
export const FAQ_DIALOG = 'FAQ_DIALOG'
// 更新日志
export const UPDATE_LOG_DIALOG = 'UPDATE_LOG_DIALOG'

// 帮助中心-公共弹窗
export const THEME = 'THEME'
export const OPENEDIT = 'OPENEDIT'



// WEBPACK FOOTER //
// ./src/store/mutations-types.js